export const getProducts = state => state.products
export const getMainProducts = state => state.main_products



// WEBPACK FOOTER //
// ./client/store/modules/products/getters.js